import { useEffect, useRef } from 'react'

const useUpdateEffect = (effect, deps) => {
    const hasMountedRef = useRef(false);

    useEffect(() => {
        if(!hasMountedRef.current) {
            hasMountedRef.current = true;
        } else {
            effect();
        }
    }, deps);
}

export default useUpdateEffect;


// WEBPACK FOOTER //
// ./src/App/hooks/useUpdateEffect.js